module.exports = __webpack_public_path__ + "46f58d408f6a338114dbd063b87f97f7.svg";